import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      overflow: 'hidden',
    };
    this.header = {};
    this.footer = {
      mt: 11,
      textAlign: 'center',
    };
    this.cta = {
      display: 'inline-block',
      alignSelf: ['flex-start', null, null, 'center'],
      flexShrink: 0,
      '@media only screen and (max-width: 767px)': {
        mx: 8,
      },
    };
  })()
);
